
import axios from "axios";

import { logOutEP } from 'endpoints';

export const getLogOutData = (state) => async dispatch => {
    await axios.get(logOutEP).then((response) => {
        return response.data;
    });
}